import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

const FilterSection = ({
  title,
  items,
  selectedItems,
  onToggle,
  getLabel,
  idPrefix = "",
  sectionId,
  labelClassName,
}) => {
  const language = useSelector((state) => state.language);

  if (!items || items.length === 0) return null;

  return (
    <FilterSectionContainer id={sectionId} className={language}>
      <div className="filter-title">{title}</div>
      <FilterList className={`filter-list ${language}`}>
        {items.map((item) => (
          <FilterItem key={item} className={language}>
            <label className={labelClassName}>{getLabel(item)}</label>
            <input
              type="checkbox"
              id={`${idPrefix}${item}`}
              checked={selectedItems.has(item)}
              onChange={() => onToggle(item)}
            />
          </FilterItem>
        ))}
      </FilterList>
    </FilterSectionContainer>
  );
};

const FilterSectionContainer = styled.div`
  margin-bottom: 15px;

  .filter-title {
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e9ecef;
  }
  @media (max-width: 768px) {
    padding: 10px 15px;
  }

  .filter-list.ar {
    padding-right: 0px !important;
    padding-left: 15px !important;
  }
`;

const FilterList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;
  padding-right: 15px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #eeeeee;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #154cd6;
    border-radius: 3px;

    &:hover {
      background: rgba(21, 76, 214, 0.76);
    }
  }
`;

const FilterItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-radius: 8px;
  transition: all 0.2s;

  label {
    font-size: 14px;
    color: #495057;
    cursor: pointer;
    flex: 1;
    font-weight: 500;
  }

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: #007bff;
  }
`;

export default FilterSection;
